<template>
  <div>
    <home v-bind:app="app"></home>
    <div
      id="fullscreen"
      class="fullscreen-container"
      @click="app.toggleFullscreen"
    >
      <img src="fullscreen.png" alt="" />
      <p>Veuillez passer en plein écran pour profiter entièrement du quizz.</p>
    </div>
  </div>
</template>

<script>
import app from "./app.js";
import home from "./components/home.vue";

export default {
  name: "App",
  components: {
    home,
  },
  data: function () {
    return {
      app: new app(),
    };
  },
  mounted() {
    this.app.init();
  },
};
</script>

<style src="./assets/css/main.css"></style>
<style src="./assets/css/level.css"></style>
<style src="./assets/css/quizz.css"></style>
<style src="./assets/css/question.css"></style>
<style src="./assets/css/score.css"></style>
<style src="./assets/css/bonus.css"></style>
<style src="./assets/css/zoom.css"></style>
<style src="./assets/css/settings.css"></style>
<style src="./assets/css/about.css"></style>
<style src="./assets/css/rules.css"></style>
<style src="./assets/css/mediaqueries.css"></style>
<style src="./assets/css/mediaqueries-tablettes.css"></style>
